export function omit<T extends object, P extends keyof T>(obj: T, objectKeys: P[]): Omit<T, P> {
  const result = { ...obj };
  objectKeys.forEach((key) => delete result[key]);
  return result;
}
